import { useQuery } from '@tanstack/react-query';

import type { GetSonarSalePurchasesOutput } from '@infinex/main-service-contract/v2/client/activity';

import type { QueryOptionsV2 } from '../config';
import { getTRPCClient } from '../config';

type SonarSalePurchasesOptions = QueryOptionsV2<GetSonarSalePurchasesOutput>;

/**
 * Hook to fetch sonar sale purchase history for the authenticated user.
 */
export function useSonarSalePurchases(options?: SonarSalePurchasesOptions) {
  return useQuery(
    getTRPCClient().activity.getSonarSalePurchases.queryOptions(undefined, {
      ...options,
    })
  );
}
